import { isEqual, pick, pickBy } from 'lodash-es';

import { IDeliveryAddress } from 'generated/graphql-gateway';
import { IPlaceAddress } from 'utils/geolocation';

import { SelectedDeliveryAddress } from './types';

export const getAddressLabel = ({ address }: SelectedDeliveryAddress) =>
  `${address.addressLine1}, ${address.city}, ${address.state} ${address.zip}, ${address.country}`;

/**
 * @name getNormalizedAddress
 * @description
 * Picks specific address values we want to compare when determining equality and removes
 * any properties that have `null`, `undefined` or `''` values.
 * @param {IDeliveryAddress & { shouldSave?: boolean }} address
 * @example
 * getNormalizedAddress({
 *  addressLine1: '123 Drury Ln',
 *  city: null,
 *  zip: undefined
 * }); // { addressLine1: '123 Drury Ln' }
 */
export const getNormalizedAddress = (address: Partial<IDeliveryAddress> | IPlaceAddress) =>
  pickBy(pick(address, ['addressLine1', 'city', 'state', 'zip', 'country']), Boolean);

export const addressExists = (addresses: IDeliveryAddress[], current: IPlaceAddress) => {
  const normalized = getNormalizedAddress(current);
  return addresses.some(addr => isEqual(getNormalizedAddress(addr), normalized));
};
